import React from 'react';
import image from "../assets/images/home_slider.png";
import imageAbout from "../assets/images/about.png";
import imageAbout2 from "../assets/images/about2.png";
import {Link} from "react-router";

const Home = () => {
    return (
        <div className='  '>
            <div
                style={{
                    backgroundImage: `url(${image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center center',
                }}
                className={'h-[100vh] flex flex-col items-start justify-center gap-4 lg:px-32 p-2'}
            >

                <p className={'text-black lg:text-5xl text-3xl font-bold '}>Experience Delice</p>
                <p className={'text-black lg:text-5xl text-xl '}>Where smoothness meets natural<br/> beauty, and results
                    that truly last.</p>
                <p className={'text-[#777] lg:text-base text-xs'}>Our journey begins with innovative ideas culminated in
                    original product <br/> formulations, utilizing unique ingredients known for their potent effects.
                </p>

            </div>


            <div className={'flex justify-center items-center py-10'}>

                <div
                    className={'max-w-screen-2xl flex flex-col lg:flex-row  justify-around items-center gap-5 flex-1 p-5'}>
                    <img src={imageAbout} alt="" className={'flex-1 max-w-[500px] w-full '}/>

                    <div className="bg-white px-6 py-12 max-w-4xl mx-auto " dir={'ltr'}>
                        {/* Section Title */}
                        <h1 className="text-3xl font-bold mb-4">About Us</h1>
                        {/* Description */}
                        <p className="text-lg text-gray-700 leading-relaxed mb-6">
                            Delice Company is a French pharmaceutical leader with over <br/>
                            <b> 10 years of expertise</b> in the research, development,<br/>
                            innovation, manufacturing, and distribution of sterile<br/>
                            medical devices, aesthetic solutions, and skincare<br/>
                            treatments tailored for beauty and medical institutes.<br/>
                        </p>
                        <Link to={'/about'}>
                            <button className={'bg-none border border-black  py-2 px-5 rounded-lg mt-5'}>LEARN MORE
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
            <div className={'flex justify-center items-center py-16'} dir={'rtl'}>

                <div
                    className={'max-w-screen-2xl flex flex-col lg:flex-row  justify-around items-center gap-5 flex-1 w-full p-5'}>
                    <img src={imageAbout2} alt="" className={'flex-1 max-w-[500px] w-full '}/>

                    <div className="bg-white  py-12 max-w-4xl p-5 md:p-0" dir={'ltr'}>
                        {/* Section Title */}
                        <h1 className="text-3xl font-bold mb-4">Our Products</h1>
                        {/* Description */}
                        <p className="text-lg text-gray-700 leading-relaxed mb-6">
                            Our diverse product range is thoughtfully designed to satisfy the unique
                            requirements of beauty clinics, dermatologists, cosmetologists, plastic
                            surgeons, doctors, pharmacies, and private hospitals.
                        </p>
                        {/* Bullet Points */}
                        <ul className="list-disc text-lg text-gray-700 leading-relaxed ml-6 mb-12">
                            <li>
                                Each product features a rich complex of active ingredients engineered
                                for visible results in skin revitalization and anti-aging.
                            </li>
                            <li>
                                We offer various formulations, allowing for customized therapy
                                options that cater to different skin needs and personal preferences.
                            </li>
                        </ul>

                        {/* Key Benefits Section */}
                        <h2 className="text-2xl font-bold mb-4">Key Product Benefits</h2>
                        <ul className="list-disc text-lg text-gray-700 leading-relaxed ml-6">
                            <li>Intensive revitalization and skin reconstruction</li>
                            <li>Deep hydration, smoothing, and tightening</li>
                            <li>
                                Tailored concentrations and combinations for personalized treatments
                            </li>
                        </ul>
                        <Link to={'/products/skin-booster'}>
                            <button className={'bg-none border border-black  py-2 px-5 rounded-lg mt-5'}>LEARN MORE
                            </button>

                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Home;